import { Pipe, PipeTransform } from '@angular/core';
import { Localization } from '../services/localization.service';

@Pipe({ name: 'stLoc' })
export class LocalizationPipe implements PipeTransform {

    constructor(
        private localizationService: Localization,
    ) {
    }

    /**
     * @param templateValues replaces substrings {0}, {1}, .. with respective values in this array
     */
    transform(key: string, ...templateValues: string[]) {
        return this.localizationService.get(key, ...templateValues);
    }
}
